import { getFlag } from '@/external-libs/fwf';
import allSettled from '../browser/allSettled';
import { logError } from '../sentry';
import formatKeyByPlatform from './formatKeyByPlatform';

/**
 * Retrieve all the flags by the current bridge of the platform
 * @param {Array} flags
 * @param {string} currentPlatform
 * @returns object
 */
async function getFlagsBySelector(flags, currentPlatform) {
  try {
    const flagsWebView = flags.map((flag) =>
      formatKeyByPlatform(flag, currentPlatform),
    );
    const promises = flagsWebView.map((flag) => getFlag(flag));
    const responses = await allSettled(promises);
    const flagsByWebView = {};
    responses.forEach((response) => {
      if (response.status === 'fulfilled') {
        flagsByWebView[response.value.keyName] = response.value;
      }
    });
    return flagsByWebView;
  } catch (error) {
    logError('[FWF][FLAGS_BY_SELECTOR]', error);
    return {};
  }
}

export default getFlagsBySelector;
